import React from 'react';
import Button from '../../../components/ui/Button';

const PipelineFilters = ({ filters, onFilterChange, onReset }) => {
  return (
    <div className="bg-card rounded-lg shadow-sm border border-border p-4 mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {/* Owner Filter */}
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">
            Owner
          </label>
          <select
            value={filters?.owner}
            onChange={(e) => onFilterChange({ ...filters, owner: e?.target?.value })}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          >
            <option value="">All Owners</option>
            <option value="Michael Chen">Michael Chen</option>
            <option value="Emily Rodriguez">Emily Rodriguez</option>
            <option value="Unassigned">Unassigned</option>
          </select>
        </div>

        {/* Score Range Filter */}
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">
            AI Score
          </label>
          <select
            value={filters?.scoreRange}
            onChange={(e) => onFilterChange({ ...filters, scoreRange: e?.target?.value })}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          >
            <option value="">All Scores</option>
            <option value="high">High (60+)</option>
            <option value="medium">Medium (40-59)</option>
            <option value="low">Low (&lt;40)</option>
          </select>
        </div>

        {/* From Date Filter */}
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">
            From Date
          </label>
          <input
            type="date"
            value={filters?.fromDate}
            onChange={(e) => onFilterChange({ ...filters, fromDate: e?.target?.value })}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          />
        </div>

        {/* To Date Filter */}
        <div>
          <label className="block text-body-sm font-medium text-foreground mb-2">
            To Date
          </label>
          <input
            type="date"
            value={filters?.toDate}
            onChange={(e) => onFilterChange({ ...filters, toDate: e?.target?.value })}
            className="w-full px-3 py-2 border border-border rounded-lg bg-input text-foreground focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-smooth"
          />
        </div>

        {/* Reset Button */}
        <div className="flex items-end">
          <Button
            variant="outline"
            onClick={onReset}
            fullWidth
            iconName="RotateCcw"
            iconPosition="left"
          >
            Reset
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PipelineFilters;